/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Paper,
  withStyles,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { CircularProgress } from "@material-ui/core";
import { loadLoggedInUserInfo } from "./../../state_management/localStorage";

import Actions from '../../fluid/Actions/ActionFactory'
import { thisTypeAnnotation } from "@babel/types";

const styles = {
  paperScrollPaper: {
    position: "absolute",
    width: "auto",
    maxHeight: "400px",
    minWidth: "40px",
    margin: "0",
    top: "52px",
    right: "10px",
  },
  backdrop: {
    backgroundColor: "transparent",
  },
};

class UserInfoCard extends React.Component {
  state = {
    signoutDialogOpen: false,
    signing_out : false,
    sign_out_error : false
  };

  cancelLogout = () => {
    this.setState({
      signoutDialogOpen: false,
    });
  };

  confirmLogout = () => {
    this.setState({...this.state, signing_out : true, sign_out_error : false}, () => {
      Actions('http_request', {
        url: "/sainapse/sign_out",
        method : "post",
        data : {}
      }).then(res => {  
        // this.setState({ signoutDialogOpen: false, signing_out : false, sign_out_error: false }, () => {
          
        // });  
        this.props.dispatch({
          type: "UPDATE_LOGGED_IN_USER_INFO",
          payload: null,
        });

        this.props.dispatch({
          type: "UPDATE_AUTH_TOKEN",
          payload: null,
        });
        sessionStorage.setItem("user_privileges", null)
        // this.props.history.push("/signout_confirm")    
      }).catch(err => {
        this.setState({signoutDialogOpen: true, signing_out : false, sign_out_error: true})
      })
    })
  };
  
  renderSignoutConfirmDialog = () => {
    return (
      <Dialog
        open={this.state.signoutDialogOpen}
        onClose={this.cancelLogout}
        aria-labelledby="user-signout-alert-dialog-title"
        aria-describedby="user-signout-alert-dialog-description"
      >
        <DialogTitle id="user-signout-alert-dialog-title">
          {`Are you sure you want to sign out, `}
          <em>{`${
            loadLoggedInUserInfo() ? loadLoggedInUserInfo().email : ""
          } ?`}</em>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="user-signout-alert-dialog-description">
            {/* this will logout the user. */}
            {this.state.sign_out_error && <Typography variant = 'caption' color = 'secondary'>Error Signing Out</Typography>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            id = "user-signout-cancel"
            onClick={this.cancelLogout} color="primary">
            Cancel
          </Button>
          <Button
            id = "user-signout-confirm"
            onClick={this.confirmLogout}
            variant="outlined"
            style={{
              color: "#ff6600",
              borderColor: "#ff6600",
            }}
            startIcon = {this.state.signing_out ? <CircularProgress style = {{color : "#ff6600"}} size = {20}/> : null}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        style={{ zIndex: 222 }}
        aria-labelledby="user-info-card"
        onClose={this.props.onClose}
        width="20%"
        height="20%"
        classes={{ paperScrollPaper: classes.paperScrollPaper }}
        BackdropProps={{
          classes: {
            root: classes.backdrop,
          },
        }}
      >
        {/* <DialogTitle id="simple-dialog-title">Set backup account</DialogTitle> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <AccountCircle
            style={{ marginTop: "10px" }}
            fontSize="large"
          ></AccountCircle>
          <Typography
            style={{
              padding: "5px 14px 10px",
              fontWeight: "450",
            }}
          >
            {loadLoggedInUserInfo() ? loadLoggedInUserInfo().email : ""}
          </Typography>
          <div
            style={{
              height: "2px",
              marginTop: "5px",
              width: "100%",
              backgroundColor: "#dbdbdb",
            }}
          ></div>
          <Button
            id = "user-signout-button"
            onClick={() => {
              this.setState({ signoutDialogOpen: true });
            }}
            style={{ width: "100%", color: "#3761BF" }}
          >
            Sign out
          </Button>
        </div>
        {this.state.signoutDialogOpen
          ? this.renderSignoutConfirmDialog()
          : null}
      </Dialog>
    );
  }
}

export default connect()(withRouter(withStyles(styles)(UserInfoCard)));
